import IConfig from '@sitegen/common/constants/config';

export const reducerHOF = (initialState: IConfig) => (state: IConfig = initialState): IConfig => {
    return state;
};

export const reducerKey = 'config';

export default reducerHOF;
